export const TOGGLE_CART = "TOGGLE_CART";

export const ADD_TO_CART = "ADD_TO_CART";
export const REMOVE_FROM_CART = "REMOVE_FROM_CART";
export const INCREASE_QUANTITY = "INCREASE_QUANTITY";
export const DECREASE_QUANTITY = "DECREASE_QUANTITY";

export const PROCEED_TO_CHECKOUT = "PROCEED_TO_CHECKOUT";

export const LOGIN_SUCCESS = "LOGIN_SUCCESS";
export const LOGOUT = "LOGOUT";

export const SET_DELIVERY_INFO = "SET_DELIVERY_INFO";
export const SET_LOADING = "SET_LOADING";
export const SET_ERROR = "SET_ERROR";

export const SET_FETCH_ORDERS = "SET_FETCH_ORDERS";

export const SET_FETCH_ADS = "SET_FETCH_ADS";

export const STORE_REDIRECT_URL = "STORE_REDIRECT_URL";

export const CLEAR_REDIRECT_URL = "CLEAR_REDIRECT_URL";
